/**
 * The self-service order flows (Add Port, Add Internet) are deprecated, and
 * their price source is gone: Chargebee was removed (CTX-42), so
 * `GET /kontroledge/pricing-plans` answers 410 and every price read "$ / month"
 * or "$0". Until the flows are retired they ask for no prices and show none;
 * choosing a term still works.
 */
export const SHOW_ORDER_PRICES = false;

/** "1 month", "12 months" — a contract term with no price attached. */
export const termLabel = (months: number): string =>
  `${months} ${months === 1 ? "month" : "months"}`;
